import { render, staticRenderFns } from "./OpecList.vue?vue&type=template&id=de82ce5e"
import script from "./OpecList.vue?vue&type=script&lang=js"
export * from "./OpecList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports